<template>
  <div class="flex agreement">
    <div class="basic">
      <agreement-profile :agreement="agreement" :edit_id="edit_id"></agreement-profile>
    </div>
    <div class="m-support">
      <agreement-pdf :agreement="agreement" :edit_id="edit_id" type="true"></agreement-pdf>
    </div>
  </div>
</template>

<script>
import AgreementPdf from './AgreementPdf.vue'

export default {
  components: {
    AgreementPdf
  },
  props: {
    agreement: Object,
    condition: Object,
    edit_id: Object
  },
  data () {
    return {
    }
  },
  computed: {
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
    })
  },
  beforeRouteLeave (to, from, next) {
    if (this.edit_id.agreement_id === this.agreement.id) {
      alert('契約情報が編集中です')
      return
    } else if (this.condition.condition) {
      alert('対応履歴が編集中です')
      return
    } else if (this.edit_id.list_id) {
      alert('対応履歴が編集中です')
      return
    }
    next()
  },
  mounted () {
  },
  route: {
  }
}
</script>

<style lang="scss" scoped>
.flex {
  display: flex;
}
.agreement {
  &:after {
    content: "\f2b5";
    font-family: FontAwesome;
    position: absolute;
    font-size: 500px;
    top: 50%;
    left: 50%;
    margin-top: -250px;
    margin-left: -250px;
    color: #ddd;
    opacity: 0.1;
    z-index: -1;
  }
}
.basic {
  max-width: 50%;
  flex-basis: 50%;
}
.m-support {
  max-width: 50%;
  flex-basis: 50%;
}
.m-box__inner {
  height: calc(100vh - 262px);
  overflow-y: scroll;
  border: 1px solid #eee;
}
.m-box__inner2 {
  height: calc(100vh - 262px);
  overflow-y: scroll;
}
</style>



// WEBPACK FOOTER //
// AgreementIndex.vue?b659374e